import { ReactElement } from 'react';
import { FormControl } from '@material-ui/core';
import PhoneInput from 'react-phone-input-2';
import styles from './PhoneFlagInput.module.scss';

interface IProps {
  label?: string;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
}

const PhoneFlagDisplay = ({
  label = '',
  value = '',
  placeholder = '',
  disabled = true,
}: IProps): ReactElement => (
  <FormControl component="fieldset" className={styles.phoneControl}>
    <PhoneInput
      country="us"
      regions={['north-america', 'europe']}
      value={value}
      disabled={disabled}
      specialLabel={label}
      onChange={() => {}}
      placeholder={placeholder}
    />
  </FormControl>
);

export default PhoneFlagDisplay;
